const useUserRole = () => {
    const userRole = localStorage.getItem("user.role") || null
    return {userRole}
  }
  
  export default useUserRole